export default {
  contact: {
    badge: 'لنتواصل',
    title: 'مستعد لتحويل عمليات أسطولك؟',
    subtitle: 'نحن هنا لمساعدتك في تحسين إدارة الأسطول بتقنية متقدمة ودعم خبراء. لنتحدث عن كيفية دفع أعمالك قدماً.',
    badges: {
      freeConsultation: 'استشارة مجانية',
      customSolutions: 'حلول مخصصة',
      expertSupport: 'دعم خبراء',
    },
    methodTitle: 'اختر طريقة التواصل المفضلة',
    methodSub: 'نحن هنا لمساعدتك عبر قنوات متعددة',
    emailUs: 'راسلنا',
    dropUsALine: 'اكتب إلينا في أي وقت',
    weGetBack: 'سنرد عليك خلال 4 ساعات',
    callUs: 'اتصل بنا',
    giveUsACall: 'اتصل بنا خلال أوقات العمل',
    businessHours: 'الإثنين–الجمعة 9 ص–6 م',
    contactNow: 'اتصل الآن',
    sendMessage: 'أرسل لنا رسالة',
    fillForm: 'املأ النموذج وسنرد عليك خلال 4 ساعات في أوقات العمل.',
    messageSent: 'تم إرسال الرسالة',
    thanksReachingOut: 'شكراً لتواصلك. سنرد عليك خلال 4 ساعات في أوقات العمل.',
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    emailAddress: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    companyName: 'اسم الشركة',
    fleetSize: 'حجم الأسطول',
    subject: 'الموضوع',
    message: 'الرسالة',
    submit: 'إرسال الرسالة',
    errorGeneric: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    placeholders: {
      firstName: 'اسمك الأول',
      lastName: 'اسم العائلة',
      email: 'you@company.com',
      phone: '+966 50 123 4567',
      company: 'شركتك',
      message: 'أخبرنا عن احتياجاتك...',
    },
    subjects: {
      general: 'استفسار عام',
      demo: 'عرض المنتج',
      pricing: 'معلومات الأسعار',
      support: 'الدعم الفني',
      partnership: 'شراكة',
      enterprise: 'حل للمؤسسات',
    },
    fleetSizes: {
      small: '1–10 مركبات',
      medium: '11–50 مركبة',
      large: '51–100 مركبة',
      xl: '101–500 مركبة',
      xxl: 'أكثر من 500 مركبة',
    },
    whyContactTitle: 'لماذا تتواصل معنا؟',
    whyContactSub: 'دعم خبراء وحلول مخصصة',
    bottomCtaTitle: 'مستعد لتحويل عمليات أسطولك؟',
    bottomCtaSub: 'انضم إلى أكثر من 100 شركة تثق بـ Geofleet لإدارة أسطولها',
    statsHappyCustomers: 'عملاء سعداء',
    statsUptime: 'وقت التشغيل',
    statsSupport: 'الدعم',
    viewPricingPlans: 'عرض خطط الأسعار',
    contactUsNow: 'اتصل بنا الآن',
    whyContact: {
      strategic: { title: 'حلول استراتيجية', description: 'استراتيجيات إدارة أسطول مصممة لأعمالك' },
      fast: { title: 'تنفيذ سريع', description: 'إعداد وإدماج سريعان' },
      expertise: { title: 'خبرة قطاعية', description: 'سنوات من الخبرة في تحسين الأسطول' },
      success: { title: 'نجاح مثبت', description: 'أكثر من 100 عميل راضٍ حول العالم' },
    },
    page: {
      eyebrow: "تحدّث إلينا",
      title: "تحدّث مع فريق Geofleet",
      subtitle: "أخبرنا عن أسطولك وسنوضح لك كيف يخفّض Geofleet التكاليف والتأخير في التسليم.",
      nextTitle: "ماذا يحدث بعد ذلك",
      steps: {
        review: "نراجع بياناتك وإعداد أسطولك.",
        call: "يتصل بك أحد المختصين خلال 4 ساعات عمل.",
        demo: "تحصل على عرض توضيحي وأسعار مخصصة لعملك.",
      },
      bookDirect: "أو احجز مكالمة مباشرة",
    },
    form: {
      name: "الاسم الكامل",
      email: "البريد الإلكتروني للعمل",
      company: "الشركة",
      country: "الدولة",
      phone: "رقم الهاتف",
      fleetSize: "كم عدد المركبات؟",
      message: "هل هناك ما يجب أن نعرفه؟",
      messagePlaceholder: "المسارات، الأدوات الحالية، ما تريد تحسينه…",
      optional: "اختياري",
      submit: "تواصل معنا",
      reassurance: "نرد خلال 4 ساعات عمل. بدون رسائل مزعجة.",
      orEmail: "يمكنك أيضاً مراسلتنا على",
      successTitle: "شكراً، {{name}}!",
      successBody: "استلمنا بياناتك وسنتصل بك خلال 4 ساعات عمل. هل تريد عدم الانتظار؟",
      bookNow: "احجز موعداً الآن",
      jobTitle: "المسمى الوظيفي",
      jobTitlePlaceholder: "مثال: رئيس العمليات",
      jobTitles: {
        founder: "مؤسس / رئيس تنفيذي",
        operations: "رئيس العمليات",
        fleet: "مدير الأسطول",
        logistics: "مدير اللوجستيات",
        dispatch: "مسؤول التوزيع",
        it: "مدير التقنية",
        procurement: "المشتريات",
      },
      solutions: "ما الذي تبحث عنه؟",
      pickAny: "اختر ما يناسبك",
      solutionOptions: {
        route_planning: "تخطيط المسارات",
        shipment_tracking: "تتبع الشحنات",
        fleet_management: "إدارة الأسطول",
        gps_tracking: "تتبع المركبات بنظام GPS",
        auto_dispatch: "التوزيع والتخصيص التلقائي",
        proof_of_delivery: "إثبات التسليم",
        driver_app: "تطبيق السائق",
        customer_notifications: "تتبع العملاء وواتساب",
        dashcam_safety: "كاميرا القيادة وسلامة السائق",
        cash_on_delivery: "الدفع عند الاستلام",
        inventory_hubs: "المخزون وعمليات المراكز",
        ai_agents: "وكلاء الذكاء الاصطناعي والأتمتة",
        analytics: "التقارير والتحليلات",
        integrations: "التكاملات وواجهة API",
      },
      errors: {
        name: "يرجى إدخال اسمك.",
        email: "يرجى إدخال بريد إلكتروني صحيح.",
        phone: "أدخل رقم هاتف صحيحاً لـ {{country}}.",
      },
    },
  },
};
